/** Contact Us is available outside the native release; preserve its explicit locale and inquiry anchor. */
const CONTACT_ORIGINS = new Set([
  'https://www.raffi-jewellers.ca',
  'https://raffi-jewellers.ca',
  'https://raffi-internal-mod-dev-staging-f924c54ebe58.herokuapp.com',
]);

export function contactLanguageHref(current: string, locale: string | undefined): string {
  if (locale !== 'en' && locale !== 'fr') return '';
  try {
    const url = new URL(current);
    if (!CONTACT_ORIGINS.has(url.origin) || url.username || url.password
      || !/^\/(?:fr\/)?contact-us\/?$/.test(url.pathname)) return '';
    url.pathname = locale === 'fr' ? '/fr/contact-us' : '/contact-us';
    url.searchParams.set('lang', locale);
    return url.href;
  } catch (_) { return ''; }
}
